export default __webpack_public_path__ + "static/media/farmerGirl.862f6f77.png";